<template>
    <div>
      <v-row align="center" class="pa-4">
          <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
              <v-btn
              icon
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              >
              <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
          </template>
          <v-list width="300" dense>
              <v-list-item
              v-if="$checkPermission('attach_key_doorphone')"
              @click.prevent="openPopupNewKey(true)"
              >
              <v-list-item-title>Добавить универсальный ключ</v-list-item-title>
              </v-list-item>
              <v-list-item
              v-if="$checkPermission('attach_key_doorphone')"
              @click.prevent="openPopupNewKey(false)"
              >
              <v-list-item-title>Добавить ключ</v-list-item-title>
              </v-list-item>
<!--              <v-list-item-->
<!--              v-if="$checkPermission('create_key')"-->
<!--              @click.prevent="newKey"-->
<!--              >-->
<!--              <v-list-item-title>Создать ключ</v-list-item-title>-->
<!--              </v-list-item>-->
              <v-list-item
              v-if="$checkPermission('import_keys_doorphone') && doorphone.physical_status !== 6"
              @click.prevent="popupImport = true"
              >
              <v-list-item-title>Загрузить ключи ИЗ устройства</v-list-item-title>
              </v-list-item>
              <v-list-item
              v-if="$checkPermission('export_keys_doorphone') && doorphone.physical_status !== 6"
              @click.prevent="popupExport = true"
              >
              <v-list-item-title>Загрузить ключи В устройство</v-list-item-title>
              </v-list-item>
          </v-list>
          </v-menu>
        <div>
          <BaseTextField
            v-model="filterName"
            :is-button="false"
            icon="mdi-magnify"
            label="Введите код ключа"
          />
        </div>
        <v-spacer></v-spacer>
        <v-tooltip bottom v-if="$checkPermission('delete_keys_by_csv_doorphone')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#B81B1B"
              class="border card-footer mt-1 mb-2"
              v-bind="attrs"
              :disabled="doorphone.physical_status === 6"
              v-on="on"
              @click.prevent="openPopupDeleteKeys()"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>Удалить ключи csv</span>
        </v-tooltip>
        <v-tooltip bottom v-if="$checkPermission('export_csv_doorphone')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click.prevent="downloadReport()"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
            </v-btn>
          </template>
          <span>Скачать отчёт</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="#4C6C93"
              class="border card-footer mt-1 mb-2"
              v-bind="attrs"
              v-on="on"
              @click="updateKeys"
            >
              <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
            </v-btn>
          </template>
          <span>Обновить</span>
        </v-tooltip>
      </v-row>
      <v-data-table
      class="table"
      :headers="headersKeys"
      :items="filteredKeys()"
      :items-per-page="15"
      :footer-props="{
          'items-per-page-options': [10, 15, 30, 50],
          showFirstLastPage: true
      }"
      sort-by="id"
      >
      <template v-slot:item.code="{ item }">
          {{ keyCode(item.code) }}
      </template>
      <template v-slot:item.universal="{ item }">
          <span v-if="item.universal === 1">Да</span>
          <span v-else>Нет</span>
      </template>
      <template v-slot:item.actions="{ item }">
          <v-row justify="center">
          <v-tooltip
              v-if="$checkPermission('detach_key_doorphone')"
              bottom
          >
              <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon
                  text
                  tile
                  small
                  class="btn__icon pa-0 mr-3"
                  width="18"
                  color="#8B939E"
                  height="18"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$set(dialogDetachKey, item.id, true)"
              >
                  <v-icon class="action-icon">
                  mdi-link-variant-remove
                  </v-icon>
              </v-btn>
              </template>
              <span>Отвязать</span>
          </v-tooltip>
          <v-dialog
              v-model="dialogDetachKey[item.id]"
              persistent
              :retain-focus="false"
              max-width="460"
          >
              <v-card>
              <v-progress-linear v-if="loadingDetachKey" indeterminate color="primary"></v-progress-linear>
              <v-card-title class="headline">Отвязать ключ?</v-card-title>
              <v-card-text class="pb-0">Подтверждая, вы отвяжите ключ из домофона.</v-card-text>
                <v-checkbox
                  v-if="displayDuplicate"
                  v-model="unbindDuplicate"
                  label="Дублировать отвязку ключа в дополнительном входе"
                  hide-details
                  dense
                  class="pl-4"
                  color="success"
                />
              <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                  color="primary darken-1"
                  text
                  @click="$set(dialogDetachKey, item.id, false)"
                  >
                  Отменить
                  </v-btn>
                  <v-btn
                  color="primary darken-1"
                  text
                  :loading="loadingDetachKey"
                  @click.prevent='detachKeyBtn(item.id)'
                  >
                  Отвязать
                  </v-btn>
              </v-card-actions>
              </v-card>
          </v-dialog>
          <v-tooltip
              v-if="$checkPermission('destroy_key')"
              bottom
          >
              <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon
                  text
                  tile
                  small
                  :disabled="doorphone.physical_status === 6"
                  class="btn__icon pa-0"
                  width="18"
                  color="#8B939E"
                  height="18"
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="$set(dialogDeleteKey, item.id, true)"
              >
                  <v-icon class="action-icon">
                  mdi-close
                  </v-icon>
              </v-btn>
              </template>
              <span>Удалить</span>
          </v-tooltip>
          <v-dialog
            v-model="dialogDeleteKey[item.id]"
            max-width="350"
          >
            <baseDeleteModal
              :active.sync="dialogDeleteKey[item.id]"
              @close="$set(dialogDeleteKey, item.id, false)"
              @submit="deleteKeyBtn(item.id)"
              messageTitle="Удалить ключ?"
              messageText="Подтверждая,вы удалите ключ из домофона."/>
          </v-dialog>
          </v-row>
      </template>
      </v-data-table>
      <v-dialog
      v-model="popupNewKey"
      max-width="600"
      lazy-validation
      persistent
      content-class="dialog-border-radius"
      >
      <v-card>
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }" v-if="!universal">Новый ключ</span>
          <span :class="{ 'text-h5' : !isDisplaySmall }" v-else>Новый ключ (универсальный)</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="closePopupNewKey"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
          <v-form
          v-model="validKey"
          ref="newKey"
          >
          <v-col cols="12">
              <v-select
              label="Свободный ключ"
              :items="popupFreeKeys()"
              :item-text="item => (item.name) ? keyCode(item.code) + ' (' + item.name + ')' : keyCode(item.code)"
              item-value="id"
              v-model='freeKeyId'
              :rules="[
                  value => !!value || 'Обязательное поле',
              ]"
              clearable
              outlined
              dense
              flat
              required
              >
                <template v-slot:prepend-item>
                  <v-list-item>
                    <v-text-field
                      v-model="searchCode"
                      placeholder="Поиск по коду"
                      solo
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            <v-checkbox
              v-if="displayDuplicate"
              v-model="freeDuplicate"
              label="Дублировать ключ в дополнительный вход"
              hide-details
              dense
              color="success"
            />
          </v-col>
          <v-card-actions>
              <div class="mx-auto">
              <v-btn
                  large
                  color="success"
                  class="text-none"
                  dense
                  @click.prevent="saveNewKey()"
              >
                  Добавить
              </v-btn>
              </div>
          </v-card-actions>
          </v-form>
      </v-card>
      </v-dialog>
      <v-dialog
      v-model="popupDeleteKeys"
      max-width="420"
      lazy-validation
      persistent
      content-class="dialog-border-radius"
      >
      <v-card>
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">Удаление ключей файлом</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="closePopupDeleteKeys"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
          <v-col v-if="$checkPermission('delete_keys_by_csv_doorphone')" cols="11" class="py-0 mt-4">
          <v-file-input
              v-model='deleteKeysFile'
              accept=".csv"
              outlined
              dense
              flat
              label="Ключи"
              :rules="[
              value => !!value || 'Обязательное поле',
              ]"
          ></v-file-input>
          </v-col>
          <v-col v-if="$checkPermission('delete_keys_by_csv_doorphone')" cols="2" class="py-0">
          </v-col>
          <v-card-actions>
          <div class="mx-auto">
              <v-btn
              large
              color="success"
              class="text-none"
              dense
              @click.prevent="deleteKeys()"
              >
              Удалить
              </v-btn>
          </div>
          </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog
      v-model="popupImport"
      max-width="550"
      content-class="dialog-border-radius"
      >
      <v-card>
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">Импорт</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="popupImport = false"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
          <v-card-text class="pt-4 text-dialog">Загрузить (импортировать) список ключей из устройства в бд?</v-card-text>
            <v-checkbox
              class="ml-4"
              v-if="displayDuplicate"
              v-model="importDuplicate"
              label="Дублировать список ключей в дополнительный вход"
              hide-details
              dense
              color="success"
            />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success darken-1" text  @click.prevent="importKeys()" :loading="isUpdatedImport">Загрузить</v-btn>
            </v-card-actions>
      </v-card>
      </v-dialog>
      <v-dialog
      v-model="popupExport"
      max-width="550"
      content-class="dialog-border-radius"
      >
      <v-card>
          <v-card class="card-header" style="box-shadow: none;">
            <span :class="{ 'text-h5' : !isDisplaySmall }">Экспорт</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  right
                  class="btn__icon pa-0"
                  style="position: absolute; right: 15px; height: 50%"
                  width="18"
                  @click="popupExport = false"
                >
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Закрыть</span>
            </v-tooltip>
          </v-card>
          <v-card-text class="pt-4 text-dialog">Загрузить (экспортировать) список ключей из бд в устройство?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" text  @click.prevent="exportKeys()" :loading="isUpdatedExport">Загрузить</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { headersKeys } from '../consts';
import baseDeleteModal from '@/components/BaseDeleteModal';
import BaseTextField from '../../../BaseTextField';

export default {
  name: 'Keys',
  components: { baseDeleteModal, BaseTextField },
  props: ['id'],
  data () {
    return {
      headersKeys,
      filterName: '',
      searchCode: '',
      dialogDetachKey: {},
      dialogDeleteKey: {},
      validKey: true,
      popupNewKey: false,
      loadingDetachKey: false,
      isDisplaySmall: false,
      isUpdatedImport: false,
      isUpdatedExport: false,
      unbindDuplicate: false,
      freeDuplicate: true,
      importDuplicate: false,
      popupDeleteKeys: false,
      popupImport: false,
      popupExport: false,
      deleteKeysFile: null,
      freeKeyId: '',
      universal: false,
    };
  },
  async created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
      rules: 'Doorphone/rules',
      freeKeys: 'Doorphone/freeKeys',
      freeUniversalKeys: 'Doorphone/freeUniversalKeys',
    }),
    displayDuplicate () {
      return (this.doorphone.type === 'M') && ((this.doorphone.additionalEntrances.length > 0) ||
        (this.doorphone.gates.length > 0));
    },
  },
  methods: {
    ...mapActions({
      getDoorphone: 'Doorphone/getDoorphone',
      getFreeKeys: 'Doorphone/getFreeKeys',
      getFreeUniversalKeys: 'Doorphone/getFreeUniversalKeys',
      addKey: 'Doorphone/addKey',
      detachKey: 'Doorphone/detachKey',
      deleteKey: 'Keys/deleteKey',
      exportCsv: 'Keys/exportCsv',
      deleteKeysByCsv: 'Doorphone/deleteKeysByCsv',
      importKeysFromDevice: 'Keys/import',
      exportKeysToDevice: 'Keys/export',
    }),
    filteredKeys () {
      if (this.filterName) {
        const search = this.filterName.toLowerCase();
        return this.doorphone.keys.filter(key =>
          this.keyCode(key.code).toLowerCase().includes(search),
        );
      } else {
        return this.doorphone.keys;
      }
    },
    keyCode (code) {
      if (!this.doorphone.device || this.doorphone.device.model !== 'Sokol-Plus') {
        return code;
      }
      const value = String(code || '').toUpperCase().replace(/[^0-9A-F]/g, '');
      return value.replace(/^0+/, '') || value;
    },
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    async updateKeys () {
      await this.getData()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    async getData () {
      await this.getDoorphone({
        id: this.$route.params.id,
      })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации о домофоне');
        });
    },
    popupFreeKeys () {
      if (this.universal) {
        return this.freeUniversalKeys.filter(key =>
          this.keyCode(key.code).toLowerCase().includes(this.searchCode.toLowerCase()),
        );
      } else {
        return this.freeKeys.filter(key =>
          this.keyCode(key.code).toLowerCase().includes(this.searchCode.toLowerCase()),
        );
      }
    },
    openPopupNewKey (universal) {
      this.freeKey = '';
      this.universal = universal;
      if (!universal) {
        this.getFreeKeys(this.$route.params.id)
          .then(() => {
            this.popupNewKey = true;
          })
          .catch(() => {
            this.$flash_warning('Ошибка при загрузке свободных ключей');
          });
      } else {
        this.getFreeUniversalKeys(this.$route.params.id)
          .then(() => {
            this.popupNewKey = true;
          })
          .catch(() => {
            this.$flash_warning('Ошибка при загрузке свободных ключей');
          });
      }
    },
    saveNewKey () {
      if (this.$refs.newKey.validate()) {
        this.addKey({
          doorphoneId: this.$route.params.id,
          duplicate: +this.freeDuplicate,
          keyId: this.freeKeyId,
        })
          .then(() => {
            this.$flash_success('Ключ добавлен');
            this.getData();
          })
          .catch((message) => {
            if (message.length > 0) {
              for (let i = 0; i < message.length; i++) {
                this.$flash_warning(message[i]);
              }
            } else {
              this.$flash_warning('Ошибка при добавлении нового общего ключа');
            }
          });
        this.popupNewKey = false;
      }
    },
    closePopupNewKey () {
      this.freeKeyId = '';
      this.$refs.newKey.resetValidation();
      this.popupNewKey = false;
    },
    detachKeyBtn (idKey) {
      this.loadingDetachKey = true;
      this.detachKey({
        doorphoneId: this.$route.params.id,
        duplicate: +this.unbindDuplicate,
        keyId: idKey,
      })
        .then(async (res) => {
          this.$flash_success('Ключ отвязан от домофона');
          if (res && res.errors) {
            const error = res.errors;
            this.$flash_danger(error);
          }
          this.dialogDetachKey[idKey] = false;
          await this.getData();
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка отвязки ключа из домофона');
          }
        })
        .finally(() => {
          this.dialogDetachKey[idKey] = false;
          this.loadingDetachKey = false;
        });
    },
    deleteKeyBtn (idKey) {
      this.deleteKey(idKey)
        .then(async (res) => {
          this.$flash_success('Ключ удалён');
          if (res && res.errors) {
            const error = res.errors;
            this.$flash_danger(error);
          }
          this.dialogDeleteKey[idKey] = false;
          await this.getData();
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка при удалении ключа');
          }
        })
        .finally(() => {
          this.dialogDeleteKey[idKey] = false;
        });
    },
    newKey () {
      this.$router.push({ name: 'NewDoorphoneKey' });
    },
    downloadReport () {
      this.exportCsv({
        agentId: this.doorphone.agent_id,
        doorphoneId: this.$route.params.id,
      })
        .then((response) => {
          const data = new Blob([response], { type: 'application/csv' });
          const a = document.createElement('a');
          a.download = 'keys.csv';
          a.href = URL.createObjectURL(data);
          a.click();
        })
        .catch((e) => {
          this.$flash_warning('Ошибка при скачивании отчёта');
        });
    },
    openPopupDeleteKeys () {
      this.popupDeleteKeys = true;
    },
    closePopupDeleteKeys () {
      this.popupDeleteKeys = false;
      this.deleteKeysFile = null;
    },
    deleteKeys () {
      const formData = new FormData();
      formData.append('keys', this.deleteKeysFile);
      this.deleteKeysByCsv({
        doorphoneId: this.$route.params.id,
        formData,
      })
        .then(() => {
          this.deleteKeysFile = null;
          this.popupDeleteKeys = false;
          this.$flash_success('Ключи удалены');
          this.getData();
          this.deleteKeysFile = null;
        });
      this.popupDeleteKeys = false;
    },
    importKeys () {
      this.isUpdatedImport = true;
      this.importKeysFromDevice({
        doorphoneId: this.$route.params.id,
        duplicate: this.importDuplicate,
      })
        .then(() => {
          this.$flash_success('Ключи загружены ИЗ устройства');
          this.getData();
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка загрузке ключей');
          }
        })
        .finally(() => {
          this.popupImport = false;
          this.isUpdatedImport = false;
        });
    },
    exportKeys () {
      this.isUpdatedExport = true;
      this.exportKeysToDevice(this.$route.params.id)
        .then(() => {
          this.$flash_success('Ключи загружены В устройство');
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            const error = err.response.data.error;
            this.$flash_warning('Ошибка: ' + error);
          } else {
            this.$flash_warning('Ошибка загрузки ключей');
          }
        })
        .finally(() => {
          this.popupExport = false;
          this.isUpdatedExport = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.keys-title {
  display: block;
  padding: 14px 10px 10px;
}
.key-filter {
  display: flex;
  flex-direction: row;
}
.input {

  &-search {
    max-width: 301px;
    width: 100%;
  }
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.text-dialog {
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
}
.action-icon {
  width: 18px !important;
  height: 18px !important;
  font-size: 18px !important;
}
.action-column {
  margin: auto;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
@media screen and (max-width: 600px) {
  .action-column {
    display: inline-grid !important;
  }
}
</style>
